/* script */

import { lodashGet } from "../functions/lodash.js";
import checkout from './checkout.vue';

const __vue_script__ = {
  extends: checkout,
  data() {
    var productValue = window.product.installments[1];

    return {
      productValue: productValue,
      allowWeekBillet: window.product.allow_week_billet,
      terms: false,
      message: "",
      message_1: "",
      message_2: "",
      ch_1: null,
      ch_2: null,
      ok_1: false,
      ok_2: false,
      code: document.location.pathname.split('/').pop(),
      p_errors_1: {
        amount: [],
        number: [],
        holder_name: [],
        exp_month: [],
        exp_year: [],
        cvv: [],
        installments: []
      },
      p_errors_2: {
        amount: [],
        number: [],
        holder_name: [],
        exp_month: [],
        exp_year: [],
        cvv: [],
        installments: []
      },
      amount1: (productValue / 2).toFixed(2),
      amount2: (productValue / 2).toFixed(2),
      p_errors: {
        zipcode: [],
        address: [],
        complement: [],
        neighborhood: [],
        state: [],
        city: [],
        amount: [],
        number: [],
        holder_name: [],
        exp_month: [],
        cvv: [],
        installments: []
      },
    }
  },
  computed: {
    isBrazil() {
      return !window.is_foreign
    },
  },
  mounted() {
    if (window.is_foreign) {
      this.getCurrency(window.shopper_country)
    }
  },
  methods: {
    changeCardData(data) {
      this.cardData = data;
    },
    changeBilletInstallments(data) {
      this.billetInstallments = data;
    },
    changeAmount1(amount) {
      var newAmount = amount;
      if (amount > this.productValue) {
        newAmount = this.productValue;
      }
      this.amount1 = newAmount;
      this.amount2 = this.productValue - newAmount;
    },
    changeAmount2(amount) {
      var newAmount = amount;
      if (amount > this.productValue) {
        newAmount = this.productValue;
      }
      this.amount2 = newAmount;
      this.amount1 = this.productValue - newAmount;
    },
    preSubmitPayment() {
      if (this.loading) return;
      this.loading = true;

      window.grecaptcha.execute({ action: "submit" })
        .then((token) => {
          window.recaptcha_token = token;
          this.submitPayment();
        })
        .catch((error) => {
          this.loading = false;
          alert('Erro no reCAPTCHA. Se o problema persistir, tente novamente em outra rede.');
          console.error(error)
        })
    },
    submitPayment() {
      this.message = "";
      this.message_1 = "";
      this.message_2 = "";
      
      if (this.type === "card" && !this.isBrazil) {
        this.submitCardStripe();
      } else if (this.type === "card") {
        this.submitCard();
      } else if (this.type === "two-cards") {
        this.submitTwoCards();
      } else if (this.type === "card-pix") {
        this.submitCardPix();
      } else if (this.type === "billet" || this.type === "billet-installments") {
        this.submitBillet();
      } else {
        this.submitPix();
      }
    },
    submitCard() {
      var form = this.$refs["form-credit-card"].form;
      form.recaptcha_token = window.recaptcha_token;
      if (this.appliedCoupon) form.coupon = this.appliedCoupon;
      if (this.multipleOrderBump.length > 0) {
        form.order_bumps = this.multipleOrderBump.map((code) => {
          return ({ offer_code: code, installments: this.multipleOrderBumpInstallments[code] })
        })
      }

      $.ajax({
        type: 'POST',
        url: window.apiUrl + "/v1/payment/card/" + this.code,
        data: JSON.stringify(form),
        contentType: "application/json",
        dataType: 'json'
      })
        .done((data) => {
          trackPurchase("card", data.transaction_id);
          setTimeout(() => {
            if (data.funnel && data.funnel.url && data.funnel.url !== "None") {
              document.location.replace(data.funnel.url_cta);
            } else {
              var upsellUrl = data.funnel && data.funnel.btf ? "&btf=" + data.funnel.btf : "";
              document.location.replace("/obrigado/" + this.code + upsellUrl);
            }
          }, 999);
        })
        .fail((error) => {
          this.loading = false;
          if (error.responseJSON) {
            this.checkRedirect(error.responseJSON);
            if (error.responseJSON.message) {
              this.message = error.responseJSON.message;
            } else {
              this.p_errors = error.responseJSON;
            }
          }
        })
    },
    submitTwoCards() {
      var data = {
        card_1: this.$refs["form-credit-card-1"].form,
        card_2: this.$refs["form-credit-card-2"].form
      };
      if (this.ch_1) { data.card_1.ch = this.ch_1; }
      if (this.ch_2) { data.card_2.ch = this.ch_2; }
      data.recaptcha_token = window.recaptcha_token;

      $.ajax({
        type: 'POST',
        url: window.apiUrl + "/v1/payment/mult-card/" + this.code,
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: 'json'
      })
        .done((data) => {
          trackPurchase("card", data.transaction_id);
          setTimeout(() => {
            if (data.funnel && data.funnel.url && data.funnel.url !== "None") {
              document.location.replace(data.funnel.url_cta);
            } else {
              var upsellUrl = data.funnel && data.funnel.btf ? "&btf=" + data.funnel.btf : "";
              document.location.replace("/obrigado/" + this.code + upsellUrl);
            }
          }, 999);
        })
        .fail((error) => {
          this.loading = false;

          if (error.responseJSON) {
            this.checkRedirect(error.responseJSON);
          }

          if (lodashGet(error, "responseJSON.message", null)) {
            this.message = error.responseJSON.message === "Stone|Aprovado" ? "" : error.responseJSON.message;
          }

          if (lodashGet(error, "responseJSON.card_1.message", null)) {
            this.message_1 = error.responseJSON.card_1.message === "Stone|Aprovado" ? "" : error.responseJSON.card_1.message;
          } else {
            this.p_errors_1 = lodashGet(error, "responseJSON.card_1", {});
          }
          if (lodashGet(error, "responseJSON.card_1.ch", null)) {
            this.ch_1 = error.responseJSON.card_1.ch;
          }
          this.ok_1 = lodashGet(error, "responseJSON.card_1.status", false);

          if (lodashGet(error, "responseJSON.card_2.message", null)) {
            this.message_2 = error.responseJSON.card_2.message === "Stone|Aprovado" ? "" : error.responseJSON.card_2.message;
          } else {
            this.p_errors_2 = lodashGet(error, "responseJSON.card_2", {})
          }
          if (lodashGet(error, "responseJSON.card_2.ch", null)) {
            this.ch_2 = error.responseJSON.card_2.ch;
          }
          this.ok_2 = lodashGet(error, "responseJSON.card_2.status", false);
        })
    },
    submitCardPix() {
      var form = JSON.parse(JSON.stringify(this.$refs["form-credit-card-pix"].form));
      form.recaptcha_token = window.recaptcha_token;

      if (this.appliedCoupon) form.coupon = this.appliedCoupon;

      $.post(window.apiUrl + "/v1/payment/card-pix/" + this.code, form)
        .done((data) => {
          trackPurchase("card", data.transaction_id);
          setTimeout(() => {
            document.location.replace("/pix/" + this.code);
          }, 999);
        })
        .fail((error) => {
          this.loading = false;
          if (error.responseJSON) {
            this.checkRedirect(error.responseJSON);
            if (error.responseJSON.message) {
              this.message = error.responseJSON.message;
            } else {
              this.p_errors = error.responseJSON;
            }
          }
        });
    },
    submitBillet() {
      var form = this.$refs["form-billet"].form;
      try {
        this.$refs["form-billet"].save();
      } catch(e) {}
      form.recaptcha_token = window.recaptcha_token;
      if (this.appliedCoupon) form.coupon = this.appliedCoupon;

      if (this.multipleOrderBump.length > 0) {
        form.order_bumps = this.multipleOrderBump.map((code) => {
          return ({ offer_code: code, installments: this.multipleOrderBumpInstallments[code] })
        })
      }

      $.ajax({
        type: 'POST',
        url: window.apiUrl + "/v1/payment/billet/" + this.code,
        data: JSON.stringify(form),
        contentType: "application/json",
        dataType: 'json'
      })
        .done((data) => {
          setTimeout(() => {
            document.location.replace("/boleto/" + this.code);
          }, 999);
        })
        .fail((error) => {
          this.loading = false;
          if (error.responseJSON) {
            this.checkRedirect(error.responseJSON);
            this.p_errors = error.responseJSON;
            if (error.responseJSON.message) {
              this.message = error.responseJSON.message === "Stone|Aprovado" ? "" : error.responseJSON.message;
            }
          }
        })
    },
    submitPix() {
      var form = {};
      form.recaptcha_token = window.recaptcha_token;
      if (this.appliedCoupon) form.coupon = this.appliedCoupon;

      if (this.multipleOrderBump.length > 0) {
        form.order_bumps = this.multipleOrderBump.map((code) => {
          return ({ offer_code: code, installments: this.multipleOrderBumpInstallments[code] })
        })
      }
      
      $.ajax({
        type: 'POST',
        url: window.apiUrl + "/v1/payment/pix/" + this.code,
        data: JSON.stringify(form),
        contentType: "application/json",
        dataType: 'json'
      })
        .done((data) => {
          setTimeout(() => {
            document.location.replace("/pix/" + this.code);
          }, 999);
        })
        .fail((error) => {
          this.loading = false;
          if (error.responseJSON) {
            this.checkRedirect(error.responseJSON);
            this.p_errors = error.responseJSON;
            if (error.responseJSON.message) {
              this.message = error.responseJSON.message === "Stone|Aprovado" ? "" : error.responseJSON.message;
            }
          }
        })
    },

    submitCardStripe() {
      this.$refs["form-stripe"].tokenize((token) => {
        var form = {
          payment_method_nonce: token.id,
          recaptcha_token: window.recaptcha_token,
          installments: 1,
        }

        if (this.appliedCoupon) form.coupon = this.appliedCoupon;
        if (this.multipleOrderBump.length > 0) {
          form.order_bumps = this.multipleOrderBump.map((code) => {
            return ({ offer_code: code, installments: this.multipleOrderBumpInstallments[code] })
          })
        }

        $.ajax({
          type: 'POST',
          url: window.apiUrl + "/v1/payment/card/" + this.code + "?gateway=stripe",
          data: JSON.stringify(form),
          contentType: "application/json",
          dataType: 'json'
        })
          .done((data) => {
            trackPurchase("card", data.transaction_id);
            setTimeout(() => {
              if (data.funnel && data.funnel.url && data.funnel.url !== "None") {
                document.location.replace(data.funnel.url_cta);
              } else {
                var upsellUrl = data.funnel && data.funnel.btf ? "&btf=" + data.funnel.btf : "";
                document.location.replace("/obrigado/" + this.code + upsellUrl);
              }
            }, 999);
          })
          .fail((error) => {
            this.loading = false;
            if (error.responseJSON) {
              this.checkRedirect(error.responseJSON);
              if (error.responseJSON.message) {
                this.message = error.responseJSON.message;
              } else {
                this.p_errors = error.responseJSON;
              }
            }
          })
      }, (errorMessage) => {
        this.message = errorMessage;
        this.loading = false;
      });
    },
    checkRedirect(responseJSON) {
      if (responseJSON.redirect) {
        setTimeout(() => {
          document.location.href = responseJSON.redirect;
        }, 1200);
      }
    },
    changeOrderBumbInstallments(data) {
      this.multipleOrderBumpInstallments = data;
    },    
  }
}

/* template */

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/pages/payment.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__